var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSortingUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02255 0.333317L9.68945 5.00022L8.55808 6.13159L5.02255 2.59606L1.48702 6.13159L0.355645 5.00022L5.02255 0.333317Z",
    fill: "#BABCBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSortingUp);
export default __webpack_public_path__ + "static/media/ic-sorting-up.972977d59969a7c1c6e2080bbb489a71.svg";
export { ForwardRef as ReactComponent };